module.exports = __webpack_public_path__ + "img/Cyclone-Testing-Station-Logo-cropped-min.ab447515.svg";